import { getSocialProofV2Template } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";
import { SOCIAL_PROOF_V2_EVENT_TYPES } from "@/constant";

const decodeFromSocialProofData = element => {
  if (!element) return {};

  return JSON.parse(decodeURIComponent(unescape(window.atob(element))));
};

const editSocialProofV2Config = (editor, shortcodeWrapper) => {
  let currentData = decodeFromSocialProofData(shortcodeWrapper.getAttribute("data-social-proof-v2-data"));

  let isValid = null;

  const socialProofWindow = editor.windowManager.openUrl({
    title: "Social Proof V2",
    url: "/social-proof-v2-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        socialProofWindow.sendMessage({
          type: SOCIAL_PROOF_V2_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      shortcodeWrapper.setAttribute(
        "data-social-proof-v2-data",
        window.btoa(escape(encodeURIComponent(JSON.stringify(currentData)))),
      );
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === SOCIAL_PROOF_V2_EVENT_TYPES.REQUEST_DATA) {
        sendData();
      }

      if (message.mceAction === SOCIAL_PROOF_V2_EVENT_TYPES.UPDATE_SOCIAL_PROOF_DATA && message.data) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === SOCIAL_PROOF_V2_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 700,
  });

  const sendData = () => {
    let existData = decodeFromSocialProofData(shortcodeWrapper.getAttribute("data-social-proof-v2-data"));
    socialProofWindow.sendMessage({
      type: SOCIAL_PROOF_V2_EVENT_TYPES.SEND_DATA,
      data: existData,
    });
  };
};

const socialProofV2Config = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;
  let isValid = null;

  const socialProofWindow = tinymce.activeEditor.windowManager.openUrl({
    title: "Social Proof V2",
    url: "/social-proof-v2-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        socialProofWindow.sendMessage({
          type: SOCIAL_PROOF_V2_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      const shortcodeWrapper = getShortcodeWrapper(
        uuid,
        shortcodeOnClick,
        getSocialProofV2Template(),
        "social-proof-v2",
      );

      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      shortcodeWrapperEl.setAttribute(
        "data-social-proof-v2-data",
        window.btoa(escape(encodeURIComponent(JSON.stringify(currentData)))),
      );

      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);

      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === SOCIAL_PROOF_V2_EVENT_TYPES.UPDATE_SOCIAL_PROOF_DATA) {
        currentData = message.data;
        isValid = true;

        return;
      }

      if (message.mceAction === SOCIAL_PROOF_V2_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 700,
  });
};

export { socialProofV2Config, editSocialProofV2Config };
